export default "/images/caret-up.svg?5d51cf8c7c6bfd491c15b7dbb789d4d6";